<template>
    <div class="relative">
        <input
            :type="type"
            :maxlength="maxlength"
            class="
                form-input
                border-2
                rounded
                w-full
                selected:border-blue-[#0F61FD]
                disabled:opacity-50 disabled:border-gray-800 disabled:bg-gray-300
                form-textarea
                bg-gray-100
            "
            :class="stateClasses"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
        />
        <Icon :name="stateName" class="absolute right-0 -translate-y-1/2 top-1/2 mr-1.5"/>
    </div>
</template>

<script>
import Textarea from "@/Components/Textarea.vue";
import Icon from "@/Components/UI/Icons/Icon.vue"

export default {
    components: { Textarea, Icon },
    props: {
        type: {
            type: String,
            default: "text",
        },
        state: {
            type: String,
            default: "default",
        },
        modelValue: {
            type: String,
        },
        maxlength: {
            type: Number,
        }
    },
    computed: {
        stateClasses() {
            if (this.state == "success") {
                return "border-green-500";
            }
            if (this.state == "error") {
                return "border-red-500";
            }
            return "border-gray-500";
        },

        stateName() {
            if (this.state == "success") {
                return "Sucesso";
            }
            if (this.state == "error") {
                return "Erro";
            }
        },
    },
    methods: {
        updateValue(value) {
            ///console.log(value);
            this.$emit("update-value", value);
        },
    },
};
</script>
